import React = require('react');
import AdmIcons from '../../../../../components/Icons/AdmIcons';

interface ISectionTitle {
  text: string;
  iconName?: string;
  color?: string
}

export const SectionTitle = ({ iconName, text, color = '' }: ISectionTitle) => {
  return (
    <div className={'policy-indicator-container'}>
      {iconName && <div><AdmIcons name={iconName} color={color}/></div>}
      <div className={'p-i-text'}>{text}</div>
    </div>
  )
}
